<div class="container">
  <div class="container-login">
    <div class="row justify-content-center">
      <div class="col-xl-6 col-lg-12 col-md-9">
        <div class="card shadow-sm my-5 px-5">
          <div class="card-body pb-5">
            <div class="row">
              <div class="col-lg-12">
                <div class="login-form">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Login</h1>
                  </div>
                  <form
                    (ngSubmit)="login()"
                    [formGroup]="loginForm"
                    aria-labelledby="title"
                  >
                    <div class="form-group">
                      <input
                        type="email"
                        class="form-control"
                        formControlName="email"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="Enter Email Address"
                        [ngClass]="{
                          'is-invalid': submitted && f.email.errors
                        }"
                      />
                      <div
                        *ngIf="submitted && f.email.errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="f.email.errors.required">
                          Email is required
                        </div>
                        <div *ngIf="f.email.errors.email">Invalid format</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control"
                        formControlName="password"
                        id="exampleInputPassword"
                        placeholder="Password"
                        [ngClass]="{
                          'is-invalid': submitted && f.password.errors
                        }"
                      />
                      <div
                        *ngIf="submitted && f.password.errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="f.password.errors.required">
                          Password is required
                        </div>
                      </div>
                    </div>
                    <ngb-alert
                      *ngIf="error"
                      type="danger"
                      [dismissible]="false"
                      >{{ error }}</ngb-alert
                    >
                    <div class="form-group mt-4">
                      <button
                        [disabled]="loading"
                        class="btn btn-primary btn-block"
                      >
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
